import {
  X,
  Wifi,
  MapPin,
  Star,
  MessageSquare,
  ArrowRight,
  Waves,
  UtensilsCrossed,
  Icon,
  ParkingCircle,
  ParkingSquare,
  BedDouble,
  Utensils,
  Flame,
  Fan,
  Clock,
  SprayCan,
  ShieldCheck,
  Droplets,
  Cross,
  PersonStanding,
  Thermometer,
  Lock,
  Bell,
  Brush,
  Dumbbell,
  Stethoscope,
  Siren,
  Shield,
  UserX,
  Sparkles,
  CreditCard,
  Key,
  Wine,
  HelpingHand,
  Package,
  Camera,
  BanIcon,
  Coffee,
  Luggage,
  CheckCircle2,
  Shirt,
  UsersRound,
  Receipt,
  UserCheck,
  XCircle,
  Baby,
  Car,
  Armchair,
  Cookie,
  Salad,
  Map,
  Sun,
  Palmtree,
  Apple,
  Users,
  Printer,
  Accessibility,
} from "lucide-react";

export const formatDailyRate = (rate: number, currency: string): string => {
  const currencySymbols: { [key: string]: string } = {
    USD: "$",
    GBP: "£",
    EUR: "€",
    SGD: "S$",
    JPY: "¥",
    AUD: "A$",
  };

  const symbol = currencySymbols[currency] || currency;
  const formattedRate = Math.round(rate);

  return `${symbol}${formattedRate}`;
};

export const iconMap = {
  Wifi: Wifi,
  ParkingCircle: ParkingCircle,
  ParkingSquare: ParkingCircle,
  BedDouble: BedDouble,
  Utensils: Utensils,
  Flame: Flame,
  Spray: SprayCan,
  Fan: Fan,
  Clock: Clock,
  ShieldCheck: ShieldCheck,
  Droplets: Droplets,
  Cross: Cross,
  PersonStanding: PersonStanding,
  Thermometer: Thermometer,
  Lock: Lock,
  Bell: Bell,
  Brush: Brush,
  Dumbbell: Dumbbell,
  Stethoscope: Stethoscope,
  Siren: Siren,
  Shield: Shield,
  UsersX: UserX,
  Sparkles: Sparkles,
  CreditCard: CreditCard,
  Key: Key,
  Wheelchair: Accessibility,
  Wine: Wine,
  UtensilsCrossed: UtensilsCrossed,
  HelpingHand: HelpingHand,
  Package: Package,
  Camera: Camera,
  BanIcon: BanIcon,
  Coffee: Coffee,
  Luggage: Luggage,
  CheckCircle2: CheckCircle2,
  Shirt: Shirt,
  UsersRound: UsersRound,
  Receipt: Receipt,
  UserCheck: UserCheck,
  XCircle: XCircle,
  Baby: Baby,
  Car: Car,
  Armchair: Armchair,
  Cookie: Cookie,
  Iron: Shirt,
  Salad: Salad,
  Map: Map,
  Sun: Sun,
  PalmTree: Palmtree,
  Apple: Apple,
  Users: Users,
  Printer: Printer,
  Star: Star,
  MapPin: MapPin,
  Pool: Waves,
};
